import { ASK_AI_CONVERSATION } from './keys';

/** Mapping array to match streaming events data to readable sentences */
export const MAPPING_STREAM_STATUS_TO_SENTENCE = {
    matching_rules: ASK_AI_CONVERSATION.MATCHING_RULES,
    searching_sources: ASK_AI_CONVERSATION.SEARCHING_SOURCES,
    // Nothing should be displayed when streaming the answer or when streaming is done
    streaming_answer: '',
    done: '',
} as const;

export const ASK_AI_FOLLOW_UP_INPUT_NAME = 'ask-ai-follow-up-input';
